import React from 'react';

function InternshipCard({ internship, onSelectDetails }) {
  const companyName = internship.companyName || internship.company;
  const logo = internship.logo || internship.image;
  const mode = internship.mode || internship.type;

  return (
    <div className="internship-card">
      <img src={logo} alt={companyName} />
      <h2>Company Name: {companyName}</h2>
      <p>City: {internship.city}</p>
      <p>Role: {internship.role}</p>
      <p>Internship Duration: {internship.duration}</p>

      <div className="internship-card-action">
        <button
          type="button"
          className="view-details-btn"
          onClick={() => onSelectDetails(internship)}
          aria-haspopup="dialog"
          aria-label={`View details for ${companyName}`}
        >
          → View Details
        </button>
      </div>

      <div
        className={`internship-type-badge ${
          mode === 'Remote' ? 'remote' : 'offline'
        }`}
      >
        {mode}
      </div>
    </div>
  );
}

export default InternshipCard;
